import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import PermissionsTable from './PermissionsTable';

function Permissions(props) {
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        axios
            .get('/admin/roles/all')
            .then((res) => {
                const { eventRoles, organisationRoles, superAdminRole, supportRoles } = res.data;
                setRoles([...eventRoles, ...organisationRoles, superAdminRole, ...supportRoles]);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    if (roles.length === 0) {
        return <div>Loading ...</div>;
    }

    return <PermissionsTable roles={roles} />;
}

export default Permissions;

if (document.getElementById('AdminPermissions')) {
    var rootEl = document.getElementById('AdminPermissions'); // data attributes below help us
    ReactDOM.render(
        <App>
            <Permissions />
        </App>,
        rootEl,
    );
}
